import type { FaireProductEntity } from "../../entity_types/product";

export const p_esoblt9h: FaireProductEntity = {
  token: "p_esoblt9h",
  type: "product",
  name: "Biggest Fan Love & Friendship Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/db786792ba5824a401a0d10bd70095eecc8e2fe9eaf669d5115c1518cac6601f/1528360033.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/cc2338d7cc44d38429dc3ed8c76cf6abeac92446fb85caacb5a93b0165423989/1528360032.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:32.114Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
